<template>
  <nav id="navMenu" :class="['nav-menu', {active: menuStore.isOpen}]">
    <ul>
      <div class="menu_open_top">
        <MenuListItem
          v-for="menuItem in menuList"
          :key="menuItem.id"
          :item="menuItem"
          @click:menuItem="handleMenuItemClick"
        />
      </div>
    </ul>
  </nav>
</template>

<script setup>
import { computed } from 'vue';
import MenuListItem from '@/components/menu/MenuListItem.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useAuthStore from '@/store/modules/auth.js';
import useMenuStore from '@/store/modules/menu.js';
import usePageNavigationHook from '@/hooks/usePageNavigation.js';
import { authMenuList, visitorMenuList } from '@/constants/menu.js';

const props = defineProps({
  userAuthenticated: {
    type: Boolean,
  },
});

const appSettings = useAppSettingsStore();
const authStore = useAuthStore();
const menuStore = useMenuStore();

const { redirectTo } = usePageNavigationHook();

const menuList = computed(() => {
  const list = props.userAuthenticated ? authMenuList : visitorMenuList;

  const blacklist = [
    { condition: appSettings.isStoreDisabled, id: 'store' },
    { condition: appSettings.isPrizesPageDisabled, id: 'prizes' },
    { condition: appSettings.isWinnersDisabled, id: 'winners' },
    { condition: appSettings.isLeaderboardDisabled, id: 'leaderboards' },
  ].filter(({ condition }) => condition)
    .map(({ id }) => id);

  return (blacklist.length > 0)
    ? list.filter(({ id }) => !blacklist.includes(id))
    : list;
});

const handleMenuItemClick = ({ id, routeName }) => {
  if (id === 'logout') {
    authStore.dispatchLogout();

    redirectTo('Login');
  } else {
    redirectTo(routeName);
  }

  menuStore.closeMenu();
};
</script>
